import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'
import _ from 'lodash'
import CircularProgress from 'material-ui/CircularProgress'

import InvoicesRepository from 'billing/infra/InvoicesRepository'
import Utils from 'billing/infra/Utils'

const InvoicesListHeader = () => {
  return (
    <div style={styles.listItemContainer}>
      <div style={styles.listColumn(true, 32, true, 'right')}>#</div>
      <div style={styles.listColumn(true)}>Status</div>
      <div style={styles.listColumn(true)}>Date</div>
      <div style={styles.listColumn(true, null, false, 'right')}>Total</div>
      <div style={styles.listColumn(true, null, false, 'right')}>Amount Due</div>
      <div style={styles.listColumn(true, null, false, 'center')}>Actions</div>
    </div>
  )
}

const InvoicesListItem = ({ index, invoice, onInvoiceViewClicked }) => {

  const invoiceDateStr = moment(invoice.invoiceDate).format('MMM Do, YYYY')
  const amountDue = Utils.getBillAmountDue(invoice)

  return (
    <div style={{ ...styles.listItemContainer, ...styles.row(index) }}>
      <div style={styles.listColumn(false, 32, true, 'right')}>{ invoice.number }</div>
      <div style={styles.listColumn()}>
        <div style={styles.statusBox(invoice.status)}>
          { invoice.status && invoice.status.toUpperCase() }
        </div>
      </div>
      <div style={styles.listColumn()}>{ invoiceDateStr }</div>
      <div style={styles.listColumn(false, null, false, 'right')}>${ invoice.total && invoice.total.toFixed(2) || 0}</div>
      <div style={styles.listColumn(false, null, false, 'right')}>${ amountDue.toFixed(2) }</div>
      <div style={styles.listColumn(false, null, false, 'center')}>
        <div style={styles.actionsContainer}>
          <div style={styles.viewLabel} onClick={() => onInvoiceViewClicked(invoice)}>View</div>
        </div>
      </div>
    </div>
  )

}

InvoicesListItem.propTypes = {
  index: PropTypes.number.isRequired,
  invoice: PropTypes.object.isRequired,
  onInvoiceViewClicked: PropTypes.func.isRequired
}

export default class InvoicesList extends React.Component {

  static propTypes = {
    style: PropTypes.object,
    filters: PropTypes.object.isRequired,
    teamId: PropTypes.string.isRequired,
    onInvoiceViewRequested: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    this.attachInvoicesListListener(this.props)
  }

  componentWillUnmount() {
    this.removeInvoicesListListener(this.props)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filters !== this.props.filters) {
      this.setState({
        loading: true
      })
      this.removeInvoicesListListener(this.props)
      this.attachInvoicesListListener(nextProps)
    }
  }

  attachInvoicesListListener = props => {
    InvoicesRepository.addInvoicesListListener(props.teamId,
      props.filters, this.onInvoicesListValue)
  }

  removeInvoicesListListener = props => {
    InvoicesRepository.removeInvoicesListListener(props.teamId,
      props.filters, this.onInvoicesListValue)
  }

  onInvoicesListValue = snapshot => {
    const value = snapshot && snapshot.val() || {}
    this.setState({
      loading: false,
      list: _.map(value)
    })
  }

  render() {
    let invoices
    if (this.state.loading) {
      invoices = <div style={styles.progress}>
        <CircularProgress thickness={2} />
      </div>
    }
    else
    if (!this.state.list.length) {
      invoices = <div style={styles.zeroItems}>No invoices have been added for this customer/contact combination.</div>
    }
    else {
      invoices = this.state.list.map((invoice, index) =>
        <InvoicesListItem
          key={invoice.id}
          index={index}
          invoice={invoice}
          onInvoiceViewClicked={this.props.onInvoiceViewRequested} />)
    }
    return (
      <div style={this.props.style}>
        <div>
          <InvoicesListHeader />
          { invoices }
        </div>
      </div>
    )
  }

}

const styles = {
  progress: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    margin: 22
  },
  row: index => ({
    backgroundColor: index % 2 ? '#eef7ff' : '#fff',
    borderBottom: 'none'
  }),
  listItemContainer: {
    display:'flex',
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 45,
    justifyContent: 'space-between',
    borderBottom: '1px solid #527da3'
  },
  listColumn: (isHeader, width, isFirstColumn, textAlign) => ({
    color: isHeader ? '#356992' : '#757575',
    fontWeight: isHeader ? 500 : 400,
    letterSpacing: isHeader ? 0.6 : null,
    fontSize: 14,
    width: width || 100,
    marginLeft: isFirstColumn ? 0 : 0,
    textAlign: textAlign || 'left',
    paddingTop: 4,
    paddingBottom: 4
  }),
  listActionsColumn: {
    width: 144,
    justifyContent: 'center'
  },
  actionsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center'
  },
  viewLabel: {
    cursor: 'pointer',
    color: '#179b93'
  },
  actionsBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginLeft: 8,
    border: 'solid 1px #9b9b9b',
    borderRadius: 3,
    width: 20,
    height: 20,
    cursor: 'pointer'
  },
  statusBox: status => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: 64,
    height: 18,
    fontSize: 10,
    color: '#fff',
    borderRadius: 2,
    border: '1px solid ' + STATUS_BOX_COLOR[status] || '#9b9b9b',
    backgroundColor: STATUS_BOX_COLOR[status] || '#9b9b9b'
  }),
  zeroItems: {
    textAlign: 'center',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: 14,
    paddingTop: 12,
    paddingBottom: 12
  }
}

const STATUS_BOX_COLOR = {
  sent: '#efad27',
  paid: '#7ed321',
  partial: '#a49fdb'
}



// WEBPACK FOOTER //
// ./src/customer/CustomerSummary/InvoicesList.js